import {
  MARKETING_CONTENT_COLUMN,
  MARKETING_STICKY_NAV_CONTENT_INSET,
  MARKETING_STICKY_NAV_CONTENT_INSET_FLOATING,
} from '@/landing/layouts/landing-layouts'

export const yeshumanContentColumn = MARKETING_CONTENT_COLUMN
export const yeshumanHeroNavPad = MARKETING_STICKY_NAV_CONTENT_INSET
export const yeshumanHeroNavPadFloating = MARKETING_STICKY_NAV_CONTENT_INSET_FLOATING

/** Section surfaces — alternate for page rhythm (see `yeshuman-workbench.css`). */
export const yeshumanBand = 'yeshuman-band'
export const yeshumanBandAlt = 'yeshuman-band-alt'
/** Soft paper shift without the dot matrix (platform band). */
export const yeshumanBandSoft = 'yeshuman-band-soft'
